'use client';
import { createContext, use } from 'react';

import { Theme } from '@/theme/themeProviderUtils';

const ThemeContext = createContext<{
  theme: Theme;
}>({
  theme: 'light',
});

export function useTheme() {
  const context = use(ThemeContext);

  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }

  return context;
}

export default function ThemeProvider({
  children,
  theme,
}: {
  children: React.ReactNode;
  theme: Theme;
}) {
  return <ThemeContext value={{ theme }}>{children}</ThemeContext>;
}
